define('OutSystems/ClientRuntime/modules/Storage/StorageType',["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var StorageType;
    (function (StorageType) {
        StorageType[StorageType["Persistent"] = 0] = "Persistent";
        StorageType[StorageType["Session"] = 1] = "Session";
    })(StorageType || (StorageType = {}));
    exports.default = StorageType;
});
//# sourceMappingURL=StorageType.js.map;
